/**
 * 浏览器存储方法
 */
const auth = {
  getItem(key) {
    return JSON.parse(localStorage.getItem(key));
  },
  setItem(key, value) {
    return localStorage.setItem(key, JSON.stringify(value));
  },
  removeItem(key) {
    return localStorage.removeItem(key);
  },
  removeAll() {
    return localStorage.clear();
  },
};

export default auth;
